<div class="container-fluid diversificador-root m-0 p-0" appFitViewport [ngClass]="{'dark-theme': isDark}">
    <!-- Panel flotante de control -->
    <div class="floating-control-panel" (mouseenter)="expandirDiv()" (mouseleave)="contraerDiv()"
        [ngClass]="{'expanded': mouseSobreDiv}">
        <div class="panel-toggle">
            <mat-icon>{{mouseSobreDiv ? 'chevron_left' : 'menu'}}</mat-icon>
        </div>
        <div class="panel-content">
            <h6 class="panel-title mb-2">Paneles</h6>
            <div class="panel-option">
                <mat-checkbox [checked]="listaMercado" (change)="showTab('lista')" [color]="'primary'">
                    Carteras
                </mat-checkbox>
            </div>
            <div class="panel-option">
                <mat-checkbox [checked]="cartera" (change)="showTab('cartera')" [color]="'primary'">
                    Cartera
                </mat-checkbox>
            </div>
        </div>
    </div>

    <div class="row-container p-0 m-0" #rowContainer>
        <div class="p-0 m-0 resizable-column lista-panel" #column3 *ngIf="listaMercado" data-key="diversificador_col_lista">
            <div class="resizer" (mousedown)="startResizing($event, column3)" title="Arrastrar para redimensionar"></div>
            <mat-card class="enrolled-created-box ccorbit-card no-scrollbar h-100">
                <mat-card-content class="h-100 d-flex flex-column">
                    <app-lista-modelo
                        [isPlanificador]="isPlanificador"
                        [isLoading]="loading"
                        [fechaHoraSuscripcion]="fechaHoraSuscripcionFormateada"
                        [class]="'h-100 flex-grow-1'"
                        (carterasOptima)="idcarterasOptimaActual = $event"
                        (cartera)="recalcularPonderador($event)"
                        (nombreCartera)="nombresugerir($event)"
                        (metaapiConflict)="onMetaapiConflict()"
                        (selectionMetaapi)="onSelectionMetaapi($event)"
                        (modelos)="modelosGrafica = $event">
                    </app-lista-modelo>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-md-2 p-0 m-0 resizable-column h-100" #column2 *ngIf="cartera" data-key="diversificador_col_cartera">
            <div class="resizer" (mousedown)="startResizing($event, column2)" title="Arrastrar para redimensionar"></div>
            <mat-card class="enrolled-created-box ccorbit-card no-scrollbar h-100">
                <mat-card-content class="h-100 d-flex flex-column">
                    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms"
                    (selectedTabChange)="onTab2Change($event)">
                    <mat-tab>
                        <ng-template mat-tab-label>
                            Modelos
                            <mat-icon class="tab-help-icon" (click)="showTabHelp('modelos', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                        </ng-template>
                    <div class="oc-content">
                        <!-- ── CARTERA ÓPTIMA ─────────────────────────────── -->
                        <div class="oc-section-header">
                            <span>CARTERA ÓPTIMA</span>
                            <mat-icon class="oc-help-icon" (click)="showCarteraHelp()" matTooltip="Ayuda">help_outline</mat-icon>
                        </div>

                        <div class="oc-grid">
                            <label class="oc-label">Capital Inicial</label>
                            <input class="oc-input" type="number" [(ngModel)]="divOptimalWallet.capitalinicial" (ngModelChange)="calcularData()">

                            <label class="oc-label">Valor Liquidativo Neto</label>
                            <input class="oc-input" type="number" [(ngModel)]="divOptimalWallet.valorLiquidativo" disabled>

                            <label class="oc-label">Efectivo</label>
                            <input class="oc-input" type="number" [(ngModel)]="divOptimalWallet.efectivo" disabled
                                [ngClass]="{'input-error-letra': !efectivopositivo}">

                            <label class="oc-label">Tipo Cuenta</label>
                            <select class="oc-select" (change)="disabledMargin($event)" [(ngModel)]="divOptimalWallet.tipocuenta" (ngModelChange)="calcularData()">
                                <option selected>Seleccionar</option>
                                <option value="{{type}}" *ngFor="let type of accountType">{{type}}</option>
                            </select>

                            <label class="oc-label">Margen Requerido %</label>
                            <input class="oc-input" type="number" [(ngModel)]="divOptimalWallet.margenRequeridoPor" (ngModelChange)="calcularData()">

                            <label class="oc-label">Control Margin Call %</label>
                            <input class="oc-input" type="number" [(ngModel)]="divOptimalWallet.controlMarginCall" (ngModelChange)="calcularData()">

                            <label class="oc-label">Margen Total</label>
                            <input class="oc-input" type="number" [(ngModel)]="divOptimalWallet.margen" disabled
                                [ngClass]="{'input-error': !existeriesgo}">

                            <label class="oc-label">Fondos Disponibles</label>
                            <input class="oc-input" type="number" [(ngModel)]="divOptimalWallet.fondosDisponibles" disabled>

                            <label class="oc-label">Poder Adquisitivo</label>
                            <input class="oc-input" type="number" [(ngModel)]="divOptimalWallet.poderCompra" disabled>

                            <label class="oc-label">Apalancamiento</label>
                            <input class="oc-input" type="number" [(ngModel)]="divOptimalWallet.apalancamiento" (ngModelChange)="calcularDataApalancamiento()">
                        </div>

                        <!-- ── CONFIGURACIÓN RIESGO ───────────────────────── -->
                        <div class="oc-section-header">
                            <span>CONFIGURACIÓN RIESGO</span>
                            <mat-icon class="oc-help-icon" (click)="showRiesgoHelp()" matTooltip="Ayuda">help_outline</mat-icon>
                        </div>

                        <div class="oc-grid">
                            <label class="oc-label">Riesgo Máximo %</label>
                            <input class="oc-input" type="number" [(ngModel)]="divOptimalWallet.riesgomaximo" (ngModelChange)="calcularData()">

                            <label class="oc-label">Tipo Riesgo</label>
                            <select class="oc-select" [(ngModel)]="divOptimalWallet.tiporiesgo" (ngModelChange)="calcularData()">
                                <option value="{{type}}" *ngFor="let type of purchaseTypes">{{type}}</option>
                            </select>

                            <label class="oc-label">Valor Riesgo</label>
                            <ng-container *ngIf="valoriresgo !== -1; else showText">
                                <input class="oc-input" type="number" [(ngModel)]="divOptimalWallet.riesgo" (ngModelChange)="calcularData()">
                            </ng-container>
                            <ng-template #showText>
                                <input class="oc-input" type="text" value="MIXTO" readonly>
                            </ng-template>

                            <label class="oc-label">Comisión 2/2</label>
                            <input class="oc-input" type="number" [(ngModel)]="divOptimalWallet.comisionbroker" (ngModelChange)="calcularData()">

                            <div class="oc-check-label">
                                <mat-slide-toggle [checked]="divOptimalWallet.chkgastogest" [(ngModel)]="divOptimalWallet.chkgastogest" [color]="'primary'">
                                    Gastos Gestión</mat-slide-toggle>
                            </div>
                            <input class="oc-input" type="number" [(ngModel)]="divOptimalWallet.gastosGestionPor" (ngModelChange)="calcularData()">

                            <div class="oc-check-label">
                                <mat-slide-toggle [checked]="divOptimalWallet.chkgastoprest" [(ngModel)]="divOptimalWallet.chkgastoprest" [color]="'primary'">
                                    Gastos Préstamo %</mat-slide-toggle>
                            </div>
                            <input class="oc-input" type="number" [(ngModel)]="divOptimalWallet.gastosPrestamoPor" (ngModelChange)="calcularData()">

                            <div class="oc-check-full">
                                <mat-slide-toggle [color]="'primary'" [checked]="divOptimalWallet.participacion"
                                    (change)="participacion($event, 'participacion')">
                                    Comprar/Vender Fracciones</mat-slide-toggle>
                            </div>

                            <div class="oc-check-full">
                                <mat-slide-toggle [color]="'primary'" [(ngModel)]="isAutomatico">
                                    Análisis Automático</mat-slide-toggle>
                            </div>
                        </div>

                        <!-- ── ACCIONES ────────────────────────────────────── -->
                        <div class="oc-actions">
                            <button mat-flat-button [disabled]="loading" (click)="walletAnalysis()" class="ccorbit oc-btn oc-btn--primary">
                                <mat-icon>analytics</mat-icon> Análisis De Cartera
                            </button>
                            <button mat-flat-button [disabled]="!isAnalisis" (click)="guardarPonderador()" class="ccorbit oc-btn oc-btn--primary">
                                <mat-icon>save</mat-icon>Automatización
                            </button>
                        </div>
                    </div>
                </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            Buscador
                            <mat-icon class="tab-help-icon" (click)="showTabHelp('buscador', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                        </ng-template>
                        <app-buscador  [context]="'diversificador'" [selectedTab2]="selectedTab2"></app-buscador>
                    </mat-tab>
                </mat-tab-group>
                </mat-card-content>
            </mat-card>
        </div>

        
        <div class="col p-0 m-0">
            <mat-card class="mb-25 enrolled-created-box no-scrollbar ccorbit-card">
                <mat-card-content class=" ">

                    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms"
                        (selectedTabChange)="onTabChange($event)">
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Gestión/Contabilidad
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('gestion', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-planificador-gestion [selectedTab]="selectedTab" [modelo]="modelo"
                                [isPlanificador]="isPlanificador" [loading]="loading" [habilitarGraficaEmbebida]="true">
                            </app-planificador-gestion>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Operaciones
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('operaciones', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-operations [selectedTab]="selectedTab" [modelo]="modelo"
                                [isPlanificador]="isPlanificador" [loading]="loading"></app-operations>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Valores liquidativos
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('valores', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-liquidating-values [selectedTab]="selectedTab" [modelo]="modelo"
                                [isPlanificador]="isPlanificador" [loading]="loading"></app-liquidating-values>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Rendimientos/Riesgos
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('rendimientos', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-rendimientoriesgo [selectedTab]="selectedTab" [modelo]="modelo"
                                [isPlanificador]="isPlanificador" [loading]="loading"></app-rendimientoriesgo>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Posiciones Cartera
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('cartera', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-cartera [selectedTab]="selectedTab" [modelo]="modelo" [isPlanificador]="isPlanificador"
                                [loading]="loading"></app-cartera>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Gráfica Análisis
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('graficaAnalisis', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-grafica-modelo [embedded]="true" [modelos]="modelosGrafica"></app-grafica-modelo>
                        </mat-tab>

                    </mat-tab-group>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>